import Validator from './Validator';

export default function validateUpdateCompanyUserSettings(form) {
  return Validator.create(form, {
    firstname: {
      validators: {
        notEmpty: {
          message: 'Vorname ist ein Pflichtfeld',
        },
      },
    },
    lastname: {
      validators: {
        notEmpty: {
          message: 'Nachname ist ein Pflichtfeld',
        },
      },
    },
    email: {
      validators: {
        notEmpty: {
          message: 'E-Mail-Adresse ist ein Pflichtfeld',
        },
        emailAddress: {
          message: 'Die eingegebene E-Mail-Adresse ist nicht korrekt',
        },
      },
    },
  });
}
